import { createAction, props } from '@ngrx/store';
import { IOrganization, OrganizationStatus } from '@shared/models';

export enum ActionTypes {
  Load        = '[Organizations] Load',
  LoadSuccess = '[Organizations] Load Success',
  LoadFail    = '[Organizations] Load Fail'
}

export const load = createAction(
  ActionTypes.Load,
  props<{ status: OrganizationStatus }>()
);

export const loadSuccess = createAction(
  ActionTypes.LoadSuccess,
  props<{ organizations: IOrganization[] }>()
);

export const loadFail = createAction(
  ActionTypes.LoadFail,
  props<{ error: string }>()
);

